// Shared Chakra style prop objects for the services admin view. Colors that
// must adapt to color mode are applied in the components via useColorModeValue.

/** Table header cell props (Chakra Th). */
export const HEAD_CELL = {
  borderColor: "transparent",
  fontSize: "10px",
  fontWeight: "700",
  letterSpacing: "0.4px",
  py: "12px",
};

/** Table body cell props (Chakra Td). */
export const BODY_CELL = {
  borderColor: "transparent",
  fontSize: "sm",
  py: "10px",
};

/** Owner type badge props. */
export const TYPE_BADGE = {
  fontSize: "9px",
  textTransform: "none",
  borderRadius: "6px",
  px: "6px",
};
